import { cn } from "@gettactic/helpers";
import { Comment } from "./Comment";
import { CommentsSectionProps } from "./types";

export const CommentsSection = ({
  comments,
  commentsLoading,
  authenticatedUser,
  editingCommentId,
  editingCommentText,
  onStartEditComment,
  onCancelEditComment,
  onEditComment,
  onDeleteComment,
  updateCommentLoading,
  onEditingCommentTextChange,
  embedded = false
}: CommentsSectionProps) => {
  const list = (
    <div className="space-y-6 text-muted-foreground text-sm">
      {commentsLoading ? (
        <div>Loading comments...</div>
      ) : comments.length === 0 ? (
        <div>No comments yet</div>
      ) : (
        comments.map((comment) => {
          const isOwnComment = comment.user.id === authenticatedUser.user?.id;

          return (
            <Comment
              key={comment.id}
              comment={comment}
              isOwnComment={isOwnComment}
              editingCommentId={editingCommentId}
              editingCommentText={editingCommentText}
              onStartEdit={onStartEditComment}
              onCancelEdit={onCancelEditComment}
              onEdit={onEditComment}
              onDelete={onDeleteComment}
              updateCommentLoading={updateCommentLoading}
              onEditingCommentTextChange={onEditingCommentTextChange}
            />
          );
        })
      )}
    </div>
  );

  // Embedded: just the list (the combined section owns the wrapper + heading).
  if (embedded) {
    return list;
  }

  // Only draw the section separator once there's data to separate from; an empty
  // "No comments yet" state should not leave a dangling hr under Request Details.
  const hasComments = comments.length > 0;
  return (
    <div
      className={cn(
        "-mx-8 mt-8 px-8 pt-6 max-sm:-mx-4 max-sm:px-4",
        hasComments && "border-neutral-100 border-t"
      )}
    >
      <h3 className="mb-2 font-medium text-lg text-neutral-900">Comments</h3>
      {list}
    </div>
  );
};
